import React from 'react';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

interface PageContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const PageContainer: React.FC<PageContainerProps> = ({ children, style }) => {
  const { spacing } = useResponsiveSizes();

  return <div style={{ maxWidth: '100%', margin: `0 ${spacing.xxl}px`, ...style }}>{children}</div>;
};
